import items from './items';
import store from './store';
import destroy from './destroy';

export default {
  items,
  store,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/clientCampaign/index.js